module.exports = __webpack_public_path__ + "img/8.bd1dd232.jpg";